import { Enums } from '@cyborg-monorepo/hunter/common';

interface DisplayNameInterface {
  tag: {
    [key in Enums.CyborgTagTypeEnum]?: string;
  };
  library: {
    [key in Enums.CyborgIndexEnum]?: string;
  };
  sort: {
    [key in Enums.CyborgSortEnum]: string;
  };
}

/**
 * The displaynames maps enums to strings, with their preferred display name.
 * Any name not populated here will outut in Capital Case format.
 */
const DisplayNames: DisplayNameInterface = {
  tag: {
    [Enums.CyborgTagTypeEnum.MITRE_TACTIC_NAMES]: 'Tactic Name',
    [Enums.CyborgTagTypeEnum.MITRE_TECHNIQUE_NAMES]: 'Technique Name',
    [Enums.CyborgTagTypeEnum.MITRE_TECHNIQUE_IDS]: 'Technique ID',
    [Enums.CyborgTagTypeEnum.TARGET_OSES]: 'Target OSes',
    [Enums.CyborgTagTypeEnum.TARGET_OS_VERSIONS]: 'Target OS Versions',
  },
  library: {
    [Enums.CyborgIndexEnum.CYBORG_USE_CASES]: 'Hunt Packages',
    [Enums.CyborgIndexEnum.CYBORG_THREAT_PROFILES]: 'Threat Profiles',
    [Enums.CyborgIndexEnum.CYBORG_COLLECTIONS]: 'Hunt Package Collections',
  },
  sort: {
    [Enums.CyborgSortEnum.RELEVANCE]: 'Relevance',
    [Enums.CyborgSortEnum.LAST_UPDATED_DESC]: 'Last Updated',
    [Enums.CyborgSortEnum.LAST_UPDATED_ASC]: 'Last Updated Asc',
    [Enums.CyborgSortEnum.CREATED_DATE_DESC]: 'Newest',
    [Enums.CyborgSortEnum.CREATED_DATE_ASC]: 'Oldest',
    [Enums.CyborgSortEnum.TYPE_ASC]: 'Type',
    [Enums.CyborgSortEnum.TYPE_DESC]: 'Type Desc',
    [Enums.CyborgSortEnum.TITLE_ASC]: 'Title',
    [Enums.CyborgSortEnum.TITLE_DESC]: 'Title Desc',
  },
};

export function libraryDisplayName(key: Enums.CyborgIndexEnum): string {
  return DisplayNames.library[key] || displayName(key);
}

export function tagDisplayName(key: Enums.CyborgTagTypeEnum | string): string {
  return DisplayNames.tag[key] || displayName(key);
}

export function sortDisplayName(key: Enums.CyborgSortEnum): string {
  return DisplayNames.sort[key];
}

export function displayName(key: Enums.CyborgTagTypeEnum | string): string {
  return key
    .toString()
    .replace(/_/g, ' ')
    .replace(/\b([a-z])/g, (c: string) => c.toUpperCase());
}
